export const module = {
    info: {
        name: 'user-customer-features',
        caption: 'user customer features'
    },
    vuexModules: ['api', 'state'],
    mainRoute: '/cpanel',
    noRoutes: true,
}

export default module
